import React from 'react';
import shotPupilApp from '../../assets/images/app-screenshots/pupil-app.png';
import StoreButtons from './StoreButtons';

function HeroPupilApp() {
    return (
        <section className="dd-hero-area dd-red dd-pupil-hero">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="dd-hero-content">
                            <span>Invited by your driving instructor?</span>
                            <h1 className="dd-title">Your driving lessons in one app</h1>
                            <p>
                                The Drive.Day pupil app is free. See your lessons, keep your details up
                                to date and stay in touch with your instructor.
                            </p>
                            <StoreButtons />
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="dd-hero-thumb dd-pupil-hero-thumb">
                            <img src={shotPupilApp} alt="The Drive.Day pupil app home screen" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default HeroPupilApp;
